export default __webpack_public_path__ + "static/media/spacer-inverted.eb469b14.png";